import { Link } from "@tanstack/react-router";
import { SafeImage } from "@/components/SafeImage";

const OfflineMode = (): JSX.Element => {
	return (
		<main className="py-3 px-3 min-h-[calc(100vh-176px)] overflow-x-hidden overflow-scroll">
			<h3 className="my-10 text-lg font-bold text-center text-primary">
				Jesteś w trybie offline
			</h3>

			<SafeImage
				src="/assets/offline_mode_cat.png"
				alt="Tryb offline"
				fallback="📴"
				className="max-w-[190px] w-[50%] my-10 mx-auto"
				onLoadSuccess={() => {
					console.log("[OfflineMode] Image loaded successfully");
				}}
				onLoadError={() => {
					console.warn("[OfflineMode] Image failed to load");
				}}
			/>

			{import.meta.env.VITE_DOWNLOAD_VIDEO_FEATURE_FLAG === "true" && (
				<div className="text-center text-lg text-fontseconadry px-2">
					Nadal możesz oglądać pobrane materiały{" "}
					<Link
						to="/offline-videos"
						className="text-blue-600 hover:text-blue-800 underline font-medium"
					>
						tutaj
					</Link>
					.
				</div>
			)}
			{import.meta.env.VITE_DOWNLOAD_VIDEO_FEATURE_FLAG !== "true" && (
				<div className="text-center text-lg text-fontseconadry px-2">
					Trwają prace nad pobieraniem materiałów offline.
				</div>
			)}
		</main>
	);
};

export default OfflineMode;
